import React from 'react';
import styled from 'styled-components';
import { useNavigate } from "react-router-dom";
import { LIGHT_PINK_ORANGE } from '../../colors';


const LogoImg = require('../../../assets/hg-logo.png');

const LogoNavigation = () => {

  const navigate = useNavigate();

  return (
    <Container>
      <Logo
        onClick={() => navigate('/')}
      >
        <div>
          <img src={LogoImg} />
        </div>
      </Logo>

    </Container>
  )
}

export default LogoNavigation;

const Container = styled.div`
  position: sticky;
  top: 0;
  z-index: 999; // ensures it's above other content
  background: ${LIGHT_PINK_ORANGE};
  display: flex;
  flex-direction: row;
  padding: 0.5rem 0.5rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1); // optional: subtle shadow when sticky
  max-height: 40px;
`;

const Logo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  div {
    height: 24px;
    
    img {
      height: 24px;
      object-fit: cover;
    }
  }
`;